import React from 'react';
import PropTypes from 'prop-types';

import FeedbackForQuestion from './FeedbackForQuestion';
import styles from '../QuestionDisplay.scss';
import feedbackService from '../../../services/FeedbackService';

class ModalFeedbackDisplay extends React.PureComponent {
    render() {
        const { question, modalFeedback } = this.props;
        const keyForModalFeedback = `modalFeedback-${question.contentRevisionId}`;
        // check in we have inline feedback -> if not, we will not render an empty dom element with styles
        const inlineFeedback = feedbackService.getParsedFeedbackForQuestion(modalFeedback, question);

        if (!inlineFeedback) return null;

        return (
            <div
                className={`${styles.feedbackForQuestion}`}
            >
                <div className="question-margin left" />
                <div className={`${styles.feedbackListBody}`}>
                    <div
                        key={keyForModalFeedback}
                        className={`${styles.modalFeedbackForQuestion}`}
                    >
                        <FeedbackForQuestion inlineFeedback={inlineFeedback} />
                    </div>
                </div>
                <div className="question-margin right" />
            </div>
        );
    }
}

ModalFeedbackDisplay.propTypes = {
    question: PropTypes.object,
    modalFeedback: PropTypes.string, // feedback for this question,
};

export default ModalFeedbackDisplay;
